import {useState, useEffect} from "react";
import {getCurrentRegion, isSubscriptionRegion} from "@/utils/regions";

// Check if URL contains ?box=otp parameter for one-time purchase preselection
const checkIsForcedOtp = () => {
  if (typeof window === 'undefined') return false;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('box') === 'otp';
};

const isForcedOtp = checkIsForcedOtp();

const useSubscription = (product, defaultSellingPlanId) => {
  const sellingPlans =
    product?.sellingPlanGroups.reduce(
      (acc, next) =>
        next?.selling_plans ? acc.concat(next?.selling_plans) : acc,
      [],
    ) ?? [];
  
  const hasNoSubscription = product?.hasNoSubscription === true;
  const hasSellingPlans = (product?.sellingPlanGroups?.length ?? 0) > 0;
  const hasSubscription = hasSellingPlans && !hasNoSubscription;
  const regionSupportsSubscription = isSubscriptionRegion(getCurrentRegion());
  
  // Start with subscription active only if: product has it, region supports it, and not forced OTP
  const shouldStartWithSubscription = hasSubscription && regionSupportsSubscription && !isForcedOtp;
  
  const [isActive, setSubscriptionActive] = useState(shouldStartWithSubscription);
  const [sellingPlanId, setSellingPlanId] = useState(() => {
    if (!shouldStartWithSubscription) return null;
    if (defaultSellingPlanId) return defaultSellingPlanId;
    return sellingPlans[0]?.id ?? null;
  });

  const getSellingPlan = id => {
    let sellingPlan = null;

    product.sellingPlanGroups?.find(({selling_plans}) => {
      const found = selling_plans.find(plan => plan.id === id);

      if (found) {
        sellingPlan = found;
      }
    });

    return sellingPlan;
  };

  useEffect(() => {
    if (!hasSubscription) {
      setSellingPlanId(null);
    }
  }, [hasSubscription]);

  useEffect(() => {
    if (!isActive) {
      setSellingPlanId(null);
    }
    if (isActive && !sellingPlanId) {
      setSellingPlanId(product?.sellingPlanGroups[0]?.selling_plans[0]?.id);
    }
  }, [isActive, product, sellingPlanId]);

  return {
    sellingPlans,
    hasSellingPlans,
    hasNoSubscription,
    hasSubscription,
    isActive,
    sellingPlanId,
    setSubscriptionActive,
    setSellingPlanId,
    getSellingPlan,
    isForcedOtp, // Export this so components can check if animation should be disabled
  };
};

export default useSubscription;
